module.exports = __webpack_public_path__ + "static/media/md_Sequencer Grid_landing page_2.3822c662.jpg";